<template>
  <v-flex class="transferFunds fill-height" data-qa="placenotice-flex-izcga">
    <v-flex xs12 sm12 md12 lg12 xl12 data-qa="placenotice-flex-nh20ej">
      <v-navigation-drawer
        v-model="openPayee"
        :width="360"
        :close-on-click="false"
        absolute
        bottom
        right
        floating
        class="transferFunds--payeeList"
        data-qa="placenotice-navigation-drawer-c13aqg">
        <v-card height="100%" data-qa="placenotice-card-26i19a">
          <v-toolbar color="white" light data-qa="placenotice-toolbar-pyv0zd">
            <v-toolbar-title data-qa="placenotice-toolbar-title-oh7r7">
              <font v-if="!enablePayeeForm">{{
                $t("transferfunds.selectPayeeLabel")
              }}</font>
              <font v-else>{{ $t("transferfunds.addPayeeHeading") }}</font>
            </v-toolbar-title>
            <v-spacer data-qa="placenotice-spacer-irojto"></v-spacer>
            <v-btn
              v-if="!enablePayeeForm && !enablePayeeFormOtherBanks"
              icon
              @click.stop="openPayee = !openPayee"
              data-qa="placenotice-btn-es58nc">
              <v-icon class="material-symbols-outlined" data-qa="placenotice-icon-mzgz5j">close</v-icon>
            </v-btn>
            <v-btn
              v-else-if="!enablePayeeFormOtherBanks"
              icon
              @click.stop="closePayeeForm"
              data-qa="placenotice-btn-mgjo12">
              <v-icon class="material-symbols-outlined" data-qa="placenotice-icon-m6alrm">close</v-icon>
            </v-btn>
            <v-btn v-else icon @click.stop="closePayeeForm" data-qa="placenotice-btn-jnzwx4">
              <v-icon class="material-symbols-outlined" data-qa="placenotice-icon-7ovvz">close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-divider data-qa="placenotice-divider-v70nkn"  />
          <!-- Own Accounts -->
          <div v-if="!enablePayeeForm" data-qa="placenotice-div-f1a8j8">
            <v-tabs
              v-model="payeeCurrentTab"
              :color="primaryColor"
              class="pt-2 pl-4"
              data-qa="placenotice-tabs-lpxnv">
              <v-tabs-slider :color="primaryColor" data-qa="placenotice-tabs-slider-t5570i"></v-tabs-slider>
              <v-tab
                v-for="(item, i) in totalPayeeTabs"
                :key="item"
                class="text-capitalize font-weight-bold"
                :data-qa="`placenotice-tab-8g2sdl-${i}`"
              >
                {{ item }}
              </v-tab>
            </v-tabs>
          </div>
          <v-tabs-items v-model="payeeCurrentTab" :color="primaryColor" data-qa="placenotice-tabs-items-ljz2ov">
            <v-tab-item data-qa="placenotice-tab-item-bx5jm8">
              <v-list-item
                two-line
                v-if="isOwnAccountsOpted && !enablePayeeForm"
                data-qa="placenotice-list-item-x2neu6">
                <v-list-item-content data-qa="placenotice-list-item-content-40u7sj">
                  <v-list-item-title data-qa="placenotice-list-item-title-tp7tp2">
                    <v-text-field data-qa="placenotice-text-field-hsafq"
                      v-model="search"
                      :label="$t('transferfunds.accountSearchLabel')"
                      :color="primaryColor"
                      prepend-inner-icon="mdi-magnify"
                      class="transferFunds--custom-textfield"
                      maxlength="20"
                      type="number"
                      clearable
                      filled
                    />
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list
                two-line
                flat
                v-if="isOwnAccountsOpted && !enablePayeeForm"
                class="mt-n10"
                data-qa="placenotice-list-oluzri">
                <v-list-item-group :color="primaryColor" data-qa="placenotice-list-item-group-8nazh">
                  <template v-for="(item, index) in filteredItems">
                    <span
                      v-if="filteredItems && item.postingsRestriction !== 'CREDIT'"
                      :key="item.accountId"
                      :data-qa="`placenotice-span-qaprga-${index}`">
                      <v-list-item
                        :key="item.heading"
                        @click="togglePayee(item, { ownAccount: true, payee: false})"
                        :data-qa="`placenotice-list-item-ssiaqc-${index}`">
                        <v-list-item-content :data-qa="`placenotice-list-item-content-56f3u-${index}`">
                          <v-list-item-title :data-qa="`placenotice-list-item-title-wl12wr-${index}`"
                            class="text--primary"
                            v-text="formatPrimaryLine(item)"
                          />
                          <v-list-item-subtitle :data-qa="`placenotice-list-item-subtitle-1vxer-${index}`"
                            v-text="formatSecondaryLine(item)"
                          />
                        </v-list-item-content>
                      </v-list-item>
                      <v-divider
                        v-if="index + 1 < filteredItems.length"
                        :key="index"
                        :data-qa="`placenotice-divider-41c2zi-${index}`"></v-divider>
                    </span>
                  </template>
                </v-list-item-group>
              </v-list>
            </v-tab-item>
            <v-tab-item data-qa="placenotice-tab-item-ok0d3k">
              <!-- Payees -->
              <v-list-item v-if="enableWithdrawalAmountPayeeForm"
                two-line
              data-qa="placenotice-list-item-uq335q">
              <v-list-item-content data-qa="placenotice-list-item-content-n0tyq">
                <v-tabs :color="primaryColor" v-model="payeeSubCurrentTab" data-qa="placenotice-tabs-l1mw3b">
                <v-tabs-slider
                  :color="primaryColor"
                data-qa="placenotice-tabs-slider-sqqoem"></v-tabs-slider>
                <v-tab
                  v-for="(item, i) in payeeSubTabs"
                  :key="item"
                  class="text-capitalize font-weight-bold"
                  :data-qa="`placenotice-tab-8g4sdl-${i}`"
                >
                  {{ item }}
                </v-tab>
              </v-tabs>
              <v-tabs-items :color="primaryColor" v-model="payeeSubCurrentTab" data-qa="placenotice-tabs-items-ia9ly">
                <v-tab-item
                  :color="primaryColor"
                  v-for="(item, i) in payeeSubTabs"
                  :key="i"
                  :data-qa="`placenotice-tab-item-8g2sdl-${i}`">
                  <v-row
                    v-if="i === 0"
                    class="pt-3 pa-1"
                    no-gutters
                    :data-qa="`placenotice-row-22kvz-${i}`">
                    <v-text-field :data-qa="`placenotice-text-field-oc5jze-${i}`"
                      v-model="sameBankSearch"
                      prepend-inner-icon="mdi-magnify"
                      :label="$t('placeNotice.searchPayee')"
                      filled
                      :color="primaryColor"
                    />
                    <v-row no-gutters justify="end" class="px-3" :data-qa="`placenotice-row-xu339h-${i}`">
                      <v-btn
                        @click="openAddPayeeForm"
                        :color="primaryColor"
                        dark
                        class="text-capitalize py-2 px-4"
                        :data-qa="`placenotice-btn-md1zd-${i}`">
                        {{ $t("transferfunds.addPayeeBtn") }}
                      </v-btn>
                    </v-row>
                    <v-list
                      v-if="filteredSameBankAccs.length"
                      subheader
                      two-line
                      :data-qa="`placenotice-list-8c25hj-${i}`">
                      <template
                        v-for="(account, index) in filteredSameBankAccs"
                      >
                        <v-list-item @click="togglePayee(account, { ownAccount: true, payee: true})" :key="account.accountNumber" :data-qa="`placenotice-list-item-1euo2w-${i}-${index}`">
                          <v-row class="ma-2 pa-2" justify="start" align="start" :data-qa="`placenotice-row-x1eg0a-${i}-${index}`">
                            <v-flex xs12 sm12 md12 lg12 xl12 :data-qa="`placenotice-flex-wb126n-${i}-${index}`">
                              <v-list-item-content :data-qa="`placenotice-list-item-content-19x76h-${i}-${index}`">
                                <v-list-item-title :data-qa="`placenotice-list-item-title-76iq8h-${i}-${index}`"
                                  class="text--primary"
                                  v-text="account.name"
                                />
                                <v-list-item-subtitle :data-qa="`placenotice-list-item-subtitle-6c5a79-${i}-${index}`"
                                  v-text="account.accountNumber"
                                />
                              </v-list-item-content>
                            </v-flex>
                          </v-row>
                        </v-list-item>
                        <v-divider
                          v-if="index < filteredSameBankAccs.length - 1"
                          :key="index"
                          :data-qa="`placenotice-divider-h7qjx-${i}-${index}`"></v-divider>
                      </template>
                    </v-list>
                    <v-row v-else no-gutters justify="center" class="mt-3 pa-2" :data-qa="`placenotice-row-9b6ncf-${i}`">
                      {{ $t('payee.notAvailable')}}
                    </v-row>
                  </v-row>
                  <v-row v-else no-gutters class="pt-3 pa-1" :data-qa="`placenotice-row-33cjk9-${i}`">
                    <v-text-field :data-qa="`placenotice-text-field-4jmkhs-${i}`"
                      v-model="otherBankSearch"
                      prepend-inner-icon="mdi-magnify"
                      :label="$t('placeNotice.searchPayee')"
                      filled
                      :color="primaryColor"
                    />
                    <v-flex
                      v-if="!(
                        appSettings.enableNominatedAccountFeatures &&
                        appSettings.enablePaymentsOnlyToNominatedAccounts
                      )" :data-qa="`placenotice-flex-qkagnr-${i}`">
                      <v-tabs
                        :color="primaryColor"
                        v-model="showLinkedAccounts"
                        :data-qa="`placenotice-tabs-8qhhy-${i}`">
                        <v-tab class="text-capitalize font-weight-bold" :data-qa="`placenotice-tab-dd8rvb-${i}`">
                          {{ $t("payee.linkedAccBtn") }}
                        </v-tab>
                        <v-tab class="text-capitalize font-weight-bold" :data-qa="`placenotice-tab-h2tyym-${i}`">
                          {{ $t("payee.payeeBtn") }}
                        </v-tab>
                      </v-tabs>
                    </v-flex>
                    <v-row no-gutters justify="end" class="py-3" :data-qa="`placenotice-row-p2blar-${i}`">
                      <v-btn
                        @click="openAddPayeeFormOtherBanks"
                        :color="primaryColor"
                        dark
                        class="text-capitalize py-2 px-4"
                        :data-qa="`placenotice-btn-w76i3n-${i}`">
                        {{ appSettings.enableNominatedAccountFeatures ?
                          $t("payee.nominatedAddNewPayeeBtn") :
                          $t("domesticPayments.addPayeeBtn") }}
                      </v-btn>
                    </v-row>
                    <v-list
                      v-if="filteredOtherBankAccs.length"
                      subheader
                      two-line
                      :data-qa="`placenotice-list-hj1rtb-${i}`">
                      <template
                        v-for="(account, index) in filteredOtherBankAccs"
                      >
                        <v-list-item @click="togglePayee(account, { ownAccount: false, payee: true})" :key="account.accountIdentification" :data-qa="`placenotice-list-item-5pnfw5-${i}-${index}`">
                          <v-row :data-qa="`placenotice-row-1mop4q-${i}-${index}`">
                            <v-flex xs12 sm12 md12 lg12 xl12 :data-qa="`placenotice-flex-qevxx-${i}-${index}`">
                              <v-list-item-content :data-qa="`placenotice-list-item-content-atcini-${i}-${index}`">
                                <v-list-item-title :data-qa="`placenotice-list-item-title-ps3zb-${i}-${index}`"
                                  class="text--primary"
                                  v-text="account.name"
                                />
                                <v-list-item-subtitle :data-qa="`placenotice-list-item-subtitle-rfvoqp-${i}-${index}`"
                                  v-text="
                                    `${account.accountIdentification} | ${account.bankIdentifier}`
                                  "
                                />
                              </v-list-item-content>
                            </v-flex>
                          </v-row>
                        </v-list-item>
                        <v-divider
                          v-if="index < filteredOtherBankAccs.length - 1"
                          :key="index"
                          :data-qa="`placenotice-divider-cgbd7n-${i}-${index}`"></v-divider>
                      </template>
                    </v-list>
                  </v-row>
                  <v-row v-if="i === 1 && !filteredOtherBankAccs.length" no-gutters justify="center" class="pa-2" :data-qa="`placenotice-row-0vbtpb-${i}`">
                    {{ $t('payee.notAvailable')}}
                  </v-row>
                </v-tab-item>
              </v-tabs-items>
              </v-list-item-content>
              </v-list-item>
              <v-list
                v-if="!isOwnAccountsOpted && !enablePayeeForm"
                two-line
                flat
                class="mt-n8"
                data-qa="placenotice-list-otbmzj">
              </v-list>
              <v-list v-if="enablePayeeForm" data-qa="placenotice-list-lppyiv">
                <v-list-item data-qa="placenotice-list-item-14t8wt">
                  <v-list-item-content data-qa="placenotice-list-item-content-ayfdf7">
                    <v-form ref="payeeForm" v-model="isPayeeFormValid" data-qa="placenotice-form-78gule">
                      <v-text-field data-qa="placenotice-text-field-u5rjn6"
                        v-model="payeeForm.accountName"
                        :label="$t('transferfunds.payeeAccountNameLabel')"
                        :color="primaryColor"
                        :rules="[rules.requiredRule]"
                        :maxlength="
                          payeeForm.payeeNameMaxLen
                            ? payeeForm.payeeNameMaxLen
                            : false
                        "
                        filled
                        class="transferFunds--custom-textfield"
                      />
                      <v-text-field data-qa="placenotice-text-field-uxoihr"
                        v-model="payeeForm.toAccount"
                        :label="$t('transferfunds.payeeAccNoLabel')"
                        :color="primaryColor"
                        :rules="[rules.requiredRule]"
                        filled
                        required
                        type="password"
                        @keydown="$formatter.validateNumberInput($event)"
                        onCopy="return false"
                        onpaste="return false"
                        class="transferFunds--custom-textfield"
                      />
                      <v-text-field data-qa="placenotice-text-field-v1zzmc"
                        v-model="payeeForm.reEnteredToAccount"
                        :label="$t('transferfunds.payeeReEnterAccNoLabel')"
                        :color="primaryColor"
                        :rules="[rules.requiredRule]"
                        :error="
                          isNumberMatched(
                            payeeForm.toAccount,
                            payeeForm.reEnteredToAccount
                          )
                        "
                        :error-messages="
                          isNumberMatched(
                            payeeForm.toAccount,
                            payeeForm.reEnteredToAccount
                          )
                            ? $t('transferfunds.errorMsgAccNumMatch')
                            : ''
                        "
                        filled
                        onCopy="return false"
                        onpaste="return false"
                        class="transferFunds--custom-textfield"
                        @keydown="$formatter.validateNumberInput($event)"
                      />
                      <v-row no-gutters justify="left" class="pa-2" data-qa="placenotice-row-7yby2">
                        <v-btn
                          @click="onAddPayee"
                          :color="primaryColor"
                          :disabled="
                            !isPayeeFormValid ||
                            isNumberMatched(
                              payeeForm.toAccount,
                              payeeForm.reEnteredToAccount
                            )
                          "

                          class="white--text text-capitalize py-2 px-4"
                          data-qa="placenotice-btn-kbvef8">
                          {{ $t("transferfunds.confirmAddPayee") }}
                        </v-btn>
                      </v-row>
                    </v-form>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
                <PlaceNoticeOtherBank
                  v-if="enablePayeeFormOtherBanks"
                  @addPayeeOtherBank = "onAddPayeeOtherBank" />
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </v-navigation-drawer>
      <v-layout wrap class="ml-2 transferFunds--gradientBGposition" data-qa="placenotice-layout-2t6ls">
        <v-flex
          xs12
          sm12
          md12
          lg12
          xl12
          :style="{ background: dashboardGradient, height: '170px' }"
          data-qa="placenotice-flex-lp86mu">
          <v-container class="transferFunds--title-padding" data-qa="placenotice-container-syqtb4">
            <v-flex xs12 sm12 md12 lg12 xl12 data-qa="placenotice-flex-hko13s">
              <v-row no-gutters data-qa="placenotice-row-yp3e2d">
                <v-layout row wrap class="pb-2 px-12" data-qa="placenotice-layout-c2l68d">
                  <inline-svg
                    class="mt-2"
                    :src="getNavigationIcon()"
                    width="40"
                    height="40"
                    aria-label="Navigation Icon"
                  />
                  <font
                    class="headline font-weight-light pt-3 px-2 white--text"
                  >
                    {{ $t("placeNotice.placeNoticeTitle") }}</font
                  >
                </v-layout>
              </v-row>
            </v-flex>
          </v-container>
        </v-flex>
      </v-layout>
      <v-flex
        xs12
        sm12
        md12
        lg12
        xl10
        class="transferFunds--content-padding transferFunds--overlayCardFlex"
        data-qa="placenotice-flex-ody7e9">
        <v-layout row wrap class="transferFunds--content-padding" data-qa="placenotice-layout-ivq4h">
          <v-flex xs12 sm10 md10 lg9 xl9 class="pt-2" data-qa="placenotice-flex-4s2eak">
            <v-flex xs12 sm11 md10 lg10 xl10 class="pt-4" data-qa="placenotice-flex-tnbl9h">
              <v-card class="pt-4" data-qa="placenotice-card-wsg8eq">
                <v-form
                  ref="form"
                  v-model="isFormValid"
                  :lazy-validation="false"
                  data-qa="placenotice-form-9kn24b">
                  <v-layout row justify-space-between data-qa="placenotice-layout-58ye4o">
                    <v-flex
                      v-if="!hideNoticeAmount"
                      xs12
                      sm12
                      md6
                      lg6
                      xl6
                      class="px-6 pt-3"
                      data-qa="placenotice-flex-o8k4gc">
                      <v-text-field data-qa="placenotice-text-field-av3hrf"
                        v-model="noticeAmount"
                        @input="
                          restrictDecimal($event);
                          validateNoticeAmount($event);
                        "
                        :label="$t('transferfunds.amountLabel')"
                        :color="primaryColor"
                        :rules="[rules.requiredAmountRule]"
                        :class="[
                          'transferFunds--custom-textfield',
                          'transferFunds--amountCurrencySymbolDefault',
                          noticeAmount && noticeAmount.length
                            ? false
                            : 'transferFunds--amountCurrencySymbol',
                        ]"
                        :hint="availableBalance ? `Balance: ${availableBalance}`: ''"
                        persistent-hint
                        :error="noticeAmountError"
                        :error-messages="noticeAmountErrorMsg"
                        filled
                        type="number"
                      />
                    </v-flex>
                    <v-flex
                      v-if="!hideWithdrawalDate"
                      xs12
                      sm12
                      md6
                      lg6
                      xl6
                      class="px-6 pt-3"
                      data-qa="placenotice-flex-76sb1p">
                      <v-menu
                        v-model="menu"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        offset-y
                        transition="scale-transition"
                        min-width="290px"
                        data-qa="placenotice-menu-hpaujslm">
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-on="on"
                            v-model="formattedDate"
                            :label="$t('placeNotice.withdrawalDate')"
                            @change="withdrawalDateValidation"
                            :color="primaryColor"
                            :rules="[rules.requiredRule]"
                            :error="withdrawalDateError"
                            :error-messages="withdrawalDateErrorMsg"
                            filled
                            readonly
                            data-qa="fromDate"
                            append-icon="mdi-calendar"
                            class="transferFunds--custom-textfield"
                          />
                        </template>
                        <v-date-picker
                          v-model="fromDate"
                          @input="menu = false"
                          @change="updateDate"
                          :min="minAllowedDate"
                          :color="primaryColor"
                          filled
                          data-qa="fromDate"
                        />
                      </v-menu>
                    </v-flex>
                    <v-flex xs12 sm12 md6 lg6 xl6 class="px-6 pt-3" data-qa="placenotice-flex-qe7wkg">
                      <v-text-field data-qa="placenotice-text-field-43kny9"
                        :value="formattedSelectedPayee"
                        @focus="listPayee"
                        :color="primaryColor"
                        :hint="formattedSelectedPayeeHint"
                        :rules="[rules.requiredRule]"
                        :label="$t('placeNotice.withdrawalAccount')"
                        filled
                        readonly
                        persistent-hint
                        append-icon="mdi-chevron-right"
                        class="transferFunds--custom-textfield"
                        @keydown="$formatter.validateNumberInput($event)"
                      />
                    </v-flex>
                    <v-flex xs12 sm12 md6 lg6 xl6 class="px-6 pt-3" v-if="withdrawalReasonFieldenabled" data-qa="placenotice-flex-ovh7z">
                      <v-autocomplete data-qa="placenotice-autocomplete-13hyp"
                        v-model="reasonForWithdrawal"
                        :items="reasonsForWithdrawal"
                        :label="$t('noticeAccountDetails.withdrawalReason')"
                        :color="primaryColor"
                        :rules="[rules.requiredRule]"
                        item-text="codeDescription"
                        item-value="codeReference"
                        filled
                        max-height="auto"
                        class="transferFunds--custom-textfield"
                        return-object
                      />
                    </v-flex>
                    <v-flex xs12 sm12 md6 lg6 xl6 class="px-6 pt-3" v-else data-qa="placenotice-flex-p4l72h">
                      <v-text-field
                        v-model="transferNote"
                        :label="$t('transferfunds.noteLabel')"
                        :color="primaryColor"
                        :rules="
                          transferNote
                            ? [
                                () =>
                                  (!!transferNote &&
                                    transferNote.length <= 100) ||
                                  $t('transferfunds.noteError'),
                              ]
                            : []
                        "
                        data-qa="placenotice-text-field-lcki6"
                        filled
                        class="transferFunds--custom-textfield"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-card-actions class="d-flex pa-6" data-qa="placenotice-card-actions-lvy2o">
                    <v-btn data-qa="placenotice-btn-xul10l"
                      outlined
                      :color="primaryColor"
                      @click="viewNoticeDetails('viewAcct')"
                      class="text-capitalize py-2 px-4"
                      v-text="$t('common.back')"
                    />
                    <v-btn data-qa="placenotice-btn-nyhs8w"
                      :color="primaryColor"
                      :disabled="!isFormValid"
                      @click="placeNoticeHandler"
                      class="text-capitalize white--text py-2 px-4"
                      v-text="$t('noticeAccountDetails.placeNoticeBtnLabel')"
                    />
                  </v-card-actions>
                </v-form>
              </v-card>
            </v-flex>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-flex>
    <!-- Confirmation modal to place notice-->
    <Modal
      v-if="showConfirmationModal"
      :config='modalConfig.confirmPlaceNotice'
      @btn1Action="viewNoticeDetails('viewNotice')">
    </Modal>
    <!-- OTP section to place notice -->
    <Modal
      v-if="showOTPScreen && enableOTPToPlaceNotice"
      :config="otpModalConfig"
      @cancel="onOtpModalClose"
    >
      <span slot="modalContent" data-qa="placenotice-span-5z3wn9">
        <OtpInput :otpConfig="otpSettings" />
      </span>
    </Modal>
  </v-flex>
</template>

<script>
import _ from 'lodash'
import '@/styles/pages/placeNotice.scss'
import commonService from '@/service/commonService.js'
import OtpInput from '@/components/common/OtpInput.vue'
import event from '@/util/event'
import preload from '@/util/preload'
import moment from 'moment'
import store from '@/core/store'
import UKFPSpayemntTemplate from '@/plugins/UKFPSconfig'
import { formatPrimaryLine, formatSecondaryLine, formatSelectedAccount, formatSelectedHint } from '../../../util/accountUtil'

export default {
  components: {
    Modal: () => import('@/components/common/Modal.vue'),
    PlaceNoticeOtherBank: () => import('@/views/accounts/accountDetails/PlaceNoticeOtherBank.vue'),
    OtpInput
  },
  data () {
    return {
      accountToPlaceNotice: {},
      defaultWithdrawDate: '',
      valid: false,
      showConfirmationModal: false,
      noticeAmount: [],
      showOTPScreen: false,
      otpModalConfig: {
        enabled: false,
        persistent: true,
        enableSave: true,
        close: true,
        saveButton: '',
        outlinedSaveBtn: false,
        title: this.$t('otp.toolBarTitle'),
        width: 400
      },
      modalConfig: {
        confirmPlaceNotice: {
          enabled: true,
          title: this.$t('placeNotice.confirmationModalTitle'),
          body: this.$t('placeNotice.subtitle'),
          persistent: true,
          btn1Label: this.$t('placeNotice.viewNoticeDetailsBtnLabel'),
          width: 500
        }
      },
      availableBalance: 0,
      formattedDate: '',
      fromDate: '',
      reasonForWithdrawal: '',
      reasonsForWithdrawal: [],
      excludedWithdrawalReasons: this.$appSettings.uiFieldsDisplayConfigurations.noticeAccountWithdrawalReasonsList.exclusionList,
      withdrawalReasonFieldenabled: this.$appSettings.defaultConfigurations.enableReasonForWithdrawalInPlaceNotice,
      transferNote: '',
      menu: false,
      openPayee: false,
      enablePayeeForm: false,
      enablePayeeFormOtherBanks: false,
      search: '',
      searchPayee: '',
      isFormValid: false,
      beneficiaryList: [],
      minWithdrawalDate: '',
      isPayeeFormValid: false,
      isOwnAccountsOpted: true,
      appSettings: this.$appSettings.defaultConfigurations.nominatedAccounts,
      minAllowedDate: '',
      enableOTPToAddPayee:
        this.$appSettings.defaultConfigurations.enableOTPToAddPayeeInPlaceNotice,
      enableOTPToPlaceNotice:
        this.$appSettings.defaultConfigurations.enableOTPToPlaceNotice,
      payeeCurrentTab: 0,
      listOfAccounts: [],
      payeeBeneficiaryId: '',
      payawayBeneficiary: false,
      isPlaceNotice: false,
      hideWithdrawalDate: false,
      withdrawalDateError: false,
      withdrawalDateErrorMsg: '',
      hideNoticeAmount: false,
      noticeAmountError: false,
      noticeAmountErrorMsg: '',
      isOwnAccLinked: null,
      UKFPSpayemntTemplate,
      payeeForm: {
        toAccount: '',
        accountName: '',
        reEnteredToAccount: '',
        payeeNameMaxLen:
          this.$appSettings.defaultConfigurations.payeeNameMaxlength.intraBank
      },
      totalPayeeTabs: [
        this.$t('transferfunds.payeeOwnAccount'),
        this.$t('transferfunds.payeeAccount')
      ],
      payeeSubCurrentTab: 0,
      payeeSubTabs: [
        this.$t('placeNotice.payeeSubTabs.tab1'),
        this.$t('placeNotice.payeeSubTabs.tab2')
      ],
      sameBankSearch: '',
      otherBankSearch: '',
      isWithdrawalToOwnAcc: false,
      sameBankAccounts: [],
      otherBankAccounts: [],
      showLinkedAccounts: 0,
      enableNoticeOnlyToNominatedAccounts: true,
      enableWithdrawalAmountPayeeForm: true,
      rules: {
        requiredRule: (v) => Boolean(v) || 'Required Field',
        requiredAmountRule: (v) =>
          (Boolean(v) && !!v.length) || this.$t('errors.common.amountRequired')
      },
      otpSettings: {
        resetPasswordTime:
          this.$appSettings.defaultConfigurations.otpResendTimeInterval,
        flex: 'xs12 sm12 md12 lg12 xl12'
      },
      noticeId: '',
      text: {
        balLabel: this.$t('common.balLabel')
      },
      excludedAccountStatus: this.$appSettings.uiFieldsDisplayConfigurations.casaAccountListing.exclusionList,
      allowInactiveAccountTransactionalOperations: this.$appSettings.defaultConfigurations.allowInactiveAccountTransactionalOperations,
      allowPaymentsToOtherISA: this.$appSettings.defaultConfigurations.payments.allowPaymentsToOtherISA,
      selectedPayee: null
    }
  },
  async created () {
    const storeData = this.$store.getters['profileStore/profileData']
    this.accountToPlaceNotice = storeData.accountToPlaceNotice
    this.getFormData(`PlaceNotice-${this.$i18n.locale}`)
    this.getListofAccounts()
    this.getSameBankAccounts()
    this.getOtherBankAccounts()
    this.withdrawalReasonFieldenabled && await this.getReasonsForWithdrawal()
    event.$on('IS_OTP_VALID', (valid) => {
      if (valid && this.showOTPScreen && (this.enableOTPToPlaceNotice || this.enableOTPToAddPayee)) {
        // this.showOTPScreen = false
        // this.otpModalConfig.enabled = false
        if (this.isPlaceNotice) {
          this.placeNotice()
        }
        this.enablePayeeForm && this.addNewPayee()
        this.enablePayeeFormOtherBanks && this.addNewPayeeOtherBank()
      } else {
        this.otpModalConfig.enableSave = true
      }
    })
    event.$on('OTP_RESENT', (val) => {
      this.otpModalConfig.enableSave = true
    })
    event.$on('isValid', (arg) => {
      this.valid = !arg
    })
  },
  computed: {
    filteredItems () {
      if (this.listOfAccounts.length) {
        return _.orderBy(
          this.listOfAccounts.filter((item) => {
            if (item.currency === this.accountToPlaceNotice.currency &&
              item.accountId !== this.accountToPlaceNotice.accountID &&
              item.accountType !== 'TXFR'
            ) {
              if (!this.search) return this.listOfAccounts
              return (
                item.accountName
                  .toLowerCase()
                  .includes(this.search.toLowerCase()) ||
                item.accountId.toLowerCase().includes(this.search.toLowerCase())
              )
            }
          })
        )
      } else return 0
    },
    filteredSameBankAccs () {
      if (this.sameBankAccounts && this.sameBankAccounts.length) {
        return this.sameBankAccounts.filter((item) => {
          const textOne = item.name.toLowerCase()
          const textTwo = item.accountNumber.toLowerCase()
          const searchText = this.sameBankSearch.toLowerCase()
          return (
            textOne.indexOf(searchText) > -1 || textTwo.indexOf(searchText) > -1
          )
        })
      }
      return this.sameBankAccounts
    },
    filteredOtherBankAccs () {
      let temp = []
      if (this.otherBankAccounts && this.otherBankAccounts.length) {
        temp = this.otherBankAccounts.filter((item) => {
          return this.showLinkedAccounts === 0
            ? item.ownAccount === true
            : item.ownAccount === false && item.currency === this.accountToPlaceNotice.currency
        })
        return temp.filter((item) => {
          if (item.currency === this.accountToPlaceNotice.currency) {
            const textOne = item.name.toLowerCase()
            const textTwo = item.accountIdentification.toLowerCase()
            const textThree = item.bankIdentifier.toLowerCase()
            const searchText = this.otherBankSearch.toLowerCase()
            return (
              textOne.indexOf(searchText) > -1 ||
              textTwo.indexOf(searchText) > -1 ||
              textThree.indexOf(searchText) > -1
            )
          }
        })
      }
      return temp
    },
    formattedSelectedPayee () {
      if (!this.selectedPayee) return ''
      if (this.selectedPayee?.accountId) {
        return formatSelectedAccount(this.selectedPayee)
      }
      return this.selectedPayee?.name
    },
    formattedSelectedPayeeHint () {
      if (!this.selectedPayee) return ''
      if (this.selectedPayee?.accountId) {
        return formatSelectedHint(this.selectedPayee)
      }
      return this.selectedPayee?.accountNumber ?? this.selectedPayee?.accountIdentification ?? ''
    },
    payAwayaccount () {
      if (this.selectedPayee?.accountId) {
        return this.selectedPayee.accountId || this.searchPayee.beneficiaryAccount
      }
      return this.selectedPayee?.accountNumber ?? this.selectedPayee?.accountIdentification ?? ''
    }
  },
  methods: {
    async getReasonsForWithdrawal () {
      const response = await commonService.getGenericCodes({ codeReferences: [{ reference: 'REASON_FOR_WITHDRAWAL' }] })
      const reasonsListArray = response?.aggregateCodes?.[0]?.codes ?? []
      this.reasonsForWithdrawal = reasonsListArray
        .filter(reason => !this.excludedWithdrawalReasons.includes(reason.codeReference))
        .sort((a, b) => a.codeDescription.localeCompare(b.codeDescription))
    },
    listPayee () {
      this.openPayee = !this.openPayee
    },
    openAddPayeeForm () {
      this.enablePayeeForm = true
      this.enableWithdrawalAmountPayeeForm = false
    },
    openAddPayeeFormOtherBanks () {
      this.enablePayeeFormOtherBanks = true
      this.enableWithdrawalAmountPayeeForm = false
    },
    closePayeeForm () {
      this.enablePayeeForm = false
      this.enablePayeeFormOtherBanks = false
      this.enableWithdrawalAmountPayeeForm = true
      // clears all fields
      this.$refs.payeeForm.reset()
    },
    isNumberMatched (firstVal, secondVal) {
      return firstVal && secondVal ? firstVal !== secondVal : false
    },
    getNavigationIcon () {
      return this.getSvgIconSrc('Savings_1')
    },
    updateDate () {
      this.formattedDate = this.$formatter.formatDate(this.fromDate)
    },
    resetDate () {
      this.formattedDate = this.$formatter.formatDate(
        this.defaultWithdrawDate.substr(0, 10)
      )
    },
    removeMasking (code) {
      return code ? code.replace(/-/g, '') : ''
    },
    convertToCapitalisedSentence (sentence) {
      return this.$formatter.convertCase.convertToCapitalisedSentence(sentence)
    },
    async getListofAccounts () {
      this.listOfAccounts = []
      const savings = []
      const savingsAcc = await preload.getAllCASAWithBalance(
        JSON.parse(sessionStorage.getItem('username'))
      )
      if (savingsAcc && savingsAcc.length) {
        let allowedAccountTypes = ['SVGS', 'CACC', 'NACC']
        if (this.allowPaymentsToOtherISA) {
          allowedAccountTypes = [...allowedAccountTypes, 'TXEA', 'TXNA']
        }
        savingsAcc.forEach(element => {
          const { accountType, accountStatus } = element

          if (allowedAccountTypes.includes(accountType)) {
            if (!this.allowInactiveAccountTransactionalOperations && accountStatus === 'INACTIVE') return
            savings.push(element)
          }
        })
        this.listOfAccounts = [...savings]
      }
    },
    async getSameBankAccounts () {
      const resp = await commonService.retrieveInternalBeneficiary(
        JSON.parse(sessionStorage.getItem('username'))
      )
      if (resp && resp.beneficiaryList) {
        this.sameBankAccounts = resp.beneficiaryList.map((item) => {
          return {
            name: item.beneficiaryReference,
            accountNumber: item.beneficiaryAccount,
            beneficiaryId: item.beneficiaryId
          }
        })
        store.dispatch('profileStore/setProfileData', {
          sameBankAccounts: this.sameBankAccounts
        })
      } else {
        this.sameBankAccounts = []
      }
    },
    async getOtherBankAccounts () {
      const resp = await commonService.getBeneficiaries(
        JSON.parse(sessionStorage.getItem('username'))
      )
      if (resp && resp.items) {
        this.otherBankAccounts = resp.items
        store.dispatch('profileStore/setProfileData', {
          otherBankAccounts: resp.items
        })
      } else {
        this.otherBankAccounts = []
      }
    },
    onAddPayee () {
      if (this.enableOTPToPlaceNotice) {
        this.showOTPScreen = true
        this.otpModalConfig.enabled = true
      } else {
        this.addNewPayee()
      }
    },
    onAddPayeeOtherBank (payeeForm, isOwnAccLinked, enablePayeeFormOtherBanks) {
      this.payeeForm = payeeForm
      this.isOwnAccLinked = isOwnAccLinked
      this.enablePayeeFormOtherBanks = enablePayeeFormOtherBanks
      if (this.enableOTPToPlaceNotice) {
        this.showOTPScreen = true
        this.otpModalConfig.enabled = true
      } else {
        this.addNewPayeeOtherBank()
      }
    },
    updateFormDate () {
      if (this.defaultWithdrawDate) {
        this.minWithdrawalDate = this.defaultWithdrawDate
      }
    },
    restrictDecimal (val) {
      if (val && val.length) {
        // Restrict the input to 2 decimal places
        this.noticeAmount = val.match(/^\d+\.?\d{0,2}/)
      }
    },
    onOtpModalClose () {
      this.otpModalConfig.enabled = false
      this.showOTPScreen = false
    },
    async getExistingPayeeList () {
      try {
        const response = await commonService.getIntraBankPayeeList(
          JSON.parse(sessionStorage.getItem('username'))
        )
        if (response && response.beneficiaryList) {
          this.beneficiaryList = response.beneficiaryList
        }
      } catch (e) {
        console.log(e)
      }
    },
    async addNewPayee () {
      // this.onOtpModalClose()
      this.$refs.payeeForm.validate()
      try {
        const payeePayload = {
          customerId: JSON.parse(sessionStorage.getItem('username')),
          beneficiaryAccount: this.payeeForm.toAccount,
          beneficiaryReference: this.payeeForm.accountName
        }
        const response = await commonService.createIntraPayeeAccount(
          payeePayload
        )
        if (response && !response.causes && response.customerId) {
          this.onOtpModalClose()
          this.$refs.payeeForm.reset()
          this.enablePayeeForm = false
          this.enableWithdrawalAmountPayeeForm = true
          this.$store.dispatch('appStore/setAppData', {
            message: {
              content: this.$t('transferfunds.addPayeeSuccessMsg'),
              type: 'success',
              component: 'dob-snackbar'
            }
          })
          // Refresh Existing Payee List Same Banks
          setTimeout(() => {
            this.getSameBankAccounts()
          }, 100)
        } else {
          if (response && response.internalType === 'OTP-ERROR') {
            event.$emit('otp_validation_failed', response)
            return
          }
          this.onOtpModalClose()
        }
      } catch (e) {
        this.onOtpModalClose()
        console.log(e)
      }
    },
    async addNewPayeeOtherBank () {
      // this.onOtpModalClose()
      try {
        const storeData = this.$store.getters['profileStore/profileData']
        const customerFullName = storeData.customerDetails
          ? storeData.fullName
          : ''
        const payeePayload = {
          customerId: JSON.parse(sessionStorage.getItem('username')),
          name: this.payeeForm.accountName || customerFullName,
          accountIdentificationType: 'PROPRIETARY',
          accountIdentification: this.payeeForm.toAccount,
          country: this.UKFPSpayemntTemplate.country,
          currency: this.UKFPSpayemntTemplate.currency,
          paymentSystem: 'UKFPS',
          bankIdentifier: this.removeMasking(this.payeeForm.sortCode),
          ownAccount: this.isOwnAccLinked === 'own'
        }
        const response = await commonService.createBeneficiaryAccount(
          payeePayload
        )
        if (response && !response.causes && response.details.customerId) {
          this.onOtpModalClose()
          // this.$refs.payeeForm.reset()
          this.enablePayeeFormOtherBanks = false
          this.enableWithdrawalAmountPayeeForm = true
          this.$store.dispatch('appStore/setAppData', {
            message: {
              content: this.$t('domesticPayments.addPayeeSuccessMsg'),
              type: 'success',
              component: 'dob-snackbar'
            }
          })
          // Refresh Existing Payee List Other Banks
          setTimeout(() => {
            this.getOtherBankAccounts()
          }, 100)
        } else {
          if (response && response.internalType === 'OTP-ERROR') {
            event.$emit('otp_validation_failed', response)
            return
          }
          this.onOtpModalClose()

          if (response && response.causes[0] && response.causes[0].code === '20600064') {
            return
          } else {
            this.$store.dispatch('appStore/setAppData', {
              message: {
                title: 'Error',
                width: 400,
                persistent: true,
                saveButton: this.$t('common.okay'),
                content: this.$t('domesticPayments.addNewPayeeError'),
                type: 'error',
                component: 'dob-modal'
              }
            })
          }
        }
      } catch (e) {
        this.onOtpModalClose()
        console.log(e)
      }
    },
    async getFormData (formName) {
      try {
        const noticePeriod = this.accountToPlaceNotice.noticePeriod
        this.availableBalance = this.accountToPlaceNotice.availableBalance
        if (noticePeriod && noticePeriod.value) {
          this.defaultWithdrawDate = moment()
            .add(noticePeriod.value, noticePeriod.unit.toLowerCase())
            .format()
        }
        if (this.defaultWithdrawDate && this.defaultWithdrawDate.length) {
          this.minAllowedDate = this.defaultWithdrawDate
          this.fromDate = this.defaultWithdrawDate.substr(0, 10)
          this.formattedDate = this.$formatter.formatDate(
            this.defaultWithdrawDate.substr(0, 10)
          )
        } else {
          const d = new Date()
          const currentDate =
            ('0' + d.getDate()).slice(-2) +
            '-' +
            ('0' + (d.getMonth() + 1)).slice(-2) +
            '-' +
            d.getFullYear()
          this.withdrawalDate = currentDate
          this.defaultWithdrawDate = currentDate
          this.minAllowedDate = new Date().toISOString().substr(0, 10)
        }
        this.updateFormDate()
      } catch (e) {
        console.log(e)
      }
    },
    togglePayee (item, ownAccount) {
      this.selectedPayee = item
      this.payeeBeneficiaryId = item.beneficiaryId
      // Check if other account
      this.isWithdrawalToOwnAcc = ownAccount.ownAccount
      this.payawayBeneficiary = ownAccount.payee
      this.openPayee = !this.openPayee
    },
    placeNoticeHandler () {
      this.isPlaceNotice = true
      this.showConfirmationModal = false
      if (this.enableOTPToPlaceNotice) {
        this.showOTPScreen = true
        this.otpModalConfig.enabled = true
      } else {
        this.placeNotice()
      }
    },
    async placeNotice () {
      const payload = {
        noticeAmount: {
          amount: parseFloat(this.noticeAmount),
          currency: this.accountToPlaceNotice.currency
        },
        withdrawalDate: this.formattedDate
          ? this.formattedDate.split('-').reverse().join('-')
          : '',
        comments: this.withdrawalReasonFieldenabled ? this.reasonForWithdrawal.codeDescription : this.transferNote || '',
        otherBankAccount: this.isWithdrawalToOwnAcc ? 'NO' : 'YES',
        payAwayaccount: this.payAwayaccount
      }

      if (this.payawayBeneficiary) {
        payload.payAwayBeneficiaryId = this.payeeBeneficiaryId
      }

      if (this.withdrawalReasonFieldenabled) {
        payload.reasonForWithdrawal = this.reasonForWithdrawal.codeReference || ''
      }

      const resp = await commonService.placeNotice(
        this.accountToPlaceNotice.accountID,
        payload
      )
      if (resp && resp.noticeId) {
        this.onOtpModalClose()
        this.isPlaceNotice = false
        this.noticeId = resp.noticeId
        this.showConfirmationModal = true
      } else {
        if (resp && resp.internalType === 'OTP-ERROR') {
          event.$emit('otp_validation_failed', resp)
          return
        }
        this.onOtpModalClose()
        this.isPlaceNotice = false
      }
    },
    viewNoticeDetails (navTab) {
      let navToTab
      this.showConfirmationModal = false
      navTab === 'viewNotice' ? navToTab = 2 : navToTab = 0
      const routeConfig = {
        name: 'AccountDetails',
        params: {
          accountId: this.accountToPlaceNotice.accountID,
          accountType: this.accountToPlaceNotice.isCashIsaAccount ? 'TXNA' : 'NACC',
          balance: this.accountToPlaceNotice.balance,
          currency: this.accountToPlaceNotice.currency,
          product: {
            postingRestrictionType:
              this.accountToPlaceNotice.postingRestrictionType
          },
          navToTab
        }
      }

      if (navTab === 'viewNotice') {
        routeConfig.params.noticeId = this.noticeId
      }

      this.$router.push(routeConfig)
    },
    validateNoticeAmount () {
      if (this.noticeAmount && this.noticeAmount.length) {
        if (parseFloat(this.noticeAmount[0]) === 0) {
          this.hideNoticeAmount = true
          this.noticeAmountError = true
          this.noticeAmountErrorMsg = this.$t('placeNotice.zeroBalErrorMsg')
          this.hideNoticeAmount = false
        } else {
          if (
            parseFloat(this.noticeAmount[0]) <=
            parseFloat(this.accountToPlaceNotice.balance)
          ) {
            this.hideNoticeAmount = true
            this.noticeAmountError = false
            this.noticeAmountErrorMsg = ''
            this.hideNoticeAmount = false
          } else if (
            parseFloat(this.noticeAmount[0]) >
            parseFloat(this.accountToPlaceNotice.balance)
          ) {
            this.hideNoticeAmount = true
            this.noticeAmountError = true
            this.noticeAmountErrorMsg = this.$t('placeNotice.invalidBalErrorMsg')
            this.hideNoticeAmount = false
          }
        }
      }
    },
    withdrawalDateValidation () {
      const defaultDate = this.defaultWithdrawDate.substr(0, 10)
      if (
        moment(this.formattedDate.split('-').reverse().join('-')).isBefore(
          defaultDate.split('-').reverse().join('-')
        )
      ) {
        this.hideWithdrawalDate = true
        this.withdrawalDateError = true
        this.withdrawalDateErrorMsg = this.$t(
          'placeNotice.invalidWithdrawalDateErrorMsg'
        )
        this.hideWithdrawalDate = false
      } else {
        this.hideWithdrawalDate = true
        this.withdrawalDateError = false
        this.withdrawalDateErrorMsg = ''
        this.hideWithdrawalDate = false
      }
    },
    formatPrimaryLine,
    formatSecondaryLine
  },
  watch: {
    payeeCurrentTab () {
      this.isOwnAccountsOpted = this.payeeCurrentTab === 0
      if (this.payeeCurrentTab === 1) {
        this.getExistingPayeeList()
      }
    },
    showOTPScreen () {
      if (this.showOTPScreen && (this.enableOTPToPlaceNotice || this.enableOTPToAddPayee)) {
        setTimeout(() => {
          event.$emit('SEND_OTP', true)
        }, 200)
      }
    }
  }
}
</script>
